module.exports = __webpack_public_path__ + "static/media/Grupo30mg01.be69f72c.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/Grupo30mg01.png
// module id = 97
// module chunks = 0